import { ISFSProduct } from 'mod/feature/interface';
import { getActivityStatus } from 'base/utils/flashsale'

export function getUniqueDates(lists: ISFSProduct[]): number[] {
    return Array.from(new Set(lists.map(item => item.startTime)));
}

export function getActiveSwiperIndex(lists: ISFSProduct[], currentTime: number): number {
    // 0) 锚点到 defaultVariant 为ture的商品
    // 1）当前时间点之前，距离当前最近的一个“秒杀开启时间”所对应的活动商品还未结束秒杀，或所有活动商品均已结束秒杀，则选中这个时间点的选项卡；
    // 2）否则，选中当前时间点之后，距离当前最近的一个“秒杀开启时间”选项卡；

    // 往前找“秒杀开启时间”最近的可加车的商品, 多个秒杀开启时间相同且可加车时，取最前面一个
    // 前面没找到，往后找下一个秒杀开始的商品
    // 所有商品都结束了，选最后一个

    const defaultVariantIndex = lists.findIndex((item) => !!item.defaultVariant)

    if (defaultVariantIndex > -1) {

        return defaultVariantIndex
    }

    const _lists = lists.map((item, index) => ({ ...item, index }));
    const prevProducts = _lists.filter(item => item.startTime <= currentTime);
    // todo: 临时最远
    // const prevDates = getUniqueDates(prevProducts).reverse();
    const prevDates = getUniqueDates(prevProducts);
    const nextProducts = _lists.filter(item => item.startTime > currentTime);

    let activeIndex = -1;


    if (prevDates.length > 0) {
        for (const date of prevDates) {
            // 多个秒杀开启时间相同且可加车时，取最前面一个
            const sameDateList = _lists.filter(item => item.startTime === date);
            for (const item of sameDateList) {
                const status = getActivityStatus(currentTime, item.startTime, item.endTime);
                if (status === 'inProgress' && item.activityStock > 0) {
                    activeIndex = item.index;
                    break;
                }
            }
            if (activeIndex > -1) {
                break;
            }
        }
    }
    if (activeIndex === -1 && nextProducts.length > 0) {
        activeIndex = nextProducts[0].index;
    }

    return activeIndex === -1 ? _lists.length - 1 : activeIndex;
}